import { LOCALSTORAGE_KEY } from "../config/general"
import { getItem } from "./localstorage"

export const isLoggedIn = () => {
	return getItem(LOCALSTORAGE_KEY) != null
}

export const handleChangeNumeric = (val, setFn) => {
	const re = /^[0-9\b]+$/;

	if (val === '') {
		setFn(0)
	} 
	
	if (re.test(val)) {
		setFn(parseInt(val))
	}
}

export const convertBytesToKB = (bytes) => Math.round(bytes / 1000)

export const isFunction = (fn) => {return typeof fn === 'function'}

export const capitalizeWord = (word) => word.charAt(0).toUpperCase() + word.slice(1)

export const roundToTwo = (num) => {
	return + (Math.round(num + "e+3") + "e-2") * 10;
}

export function normalizarBooleano(valor) {
    if (valor === true || valor === 1 || valor === '1') return true
    if (valor === false || valor === 0 || valor === '0') return false
    return false // Por defecto false
}
